/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Card from '../../../components/layout/Card';
import { Flex, Grid, MarginHandler } from '../../../styledComponents';
import ButtonCom from '../../../components/button/ButtonCom';
import TransitionsModal from '../../../components/modal/Modal';
import InputControl from '../../../components/input/InputControl';
import { FormControlLabel, Checkbox, FormGroup, FormControl, FormLabel, IconButton, Tooltip, Box, Typography, Button, InputLabel, Select, MenuItem, List, ListItem, ListItemText, ListItemSecondaryAction } from '@mui/material';
import { colors, fonts } from '../../../utils';
import FilledSelectOption from '../../../components/input/FilledSelectOption';
import { endPoints } from '../../../api/apiEndpoints';
import { Api } from '../../../api/api';
// import { setAllPostCategories } from '../../../redux/slices/posts/posts';
import { errorNotify, successNotify } from '../../../utils/helper';
import Table from '../../../components/table/Table';
import EditIcon from '@mui/icons-material/Edit';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { useNavigate } from 'react-router-dom';
import DeleteModal from '../../../components/deletemodal/DeleteModal';
import moment from 'moment';
import { setAllPermissions } from '../../../redux/slices/permissions/permissions';

const styles = {
	box: {
		border: "1px solid lightgrey",
		padding: "3rem",
		width: "100%",
		marginTop: "2em",
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	slide: {
		width: "200px",
		height: "200px",
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		margin: "2em",
		border: "1px solid lightgrey",
		padding: "10px"

	},
	img: {
		width: "100%",
		margin: "auto"
	},
	slider: {
		display: "flex",
		alignItems: "center",

	}

};

const PermissionsDialog = ({ data, handleCloseModal, isOpen, setDialogData, isEditing, userRules, getPermissions }) => {
	const dispatch = useDispatch();
	const { clientId, userId, fullName } = useSelector((state) => state?.activeAccount);
	const { primaryFont } = fonts;

	const { colorWhite, colorPrimary, colorGreenGradient } = colors;

	const { permissions } = useSelector((state) => state?.permissions);
	const [rules, setRules] = useState([]);
	const [showRuleSet, setShowRuleSet] = useState(false);
	const [currentRules, setCurrenconsumertRules] = useState(data.rule_set);
	const [enabled, setEnabled] = useState(data.enabled);
	const [consumer, setConsumer] = useState(data?.consumer);

	const fileInputRef = useRef(null);
	const [formData, setFormData] = useState({
		question: '',
		answer: '',
		type: '',
	});
	// const [userRules, setUserRules] = useState([]);


	const handleChange = (e) => {
		setDialogData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};



	const handleDeletePermission = async () => {

		try {

			await Api.post(endPoints?.faqs?.delete, {
				...formData
			}, {
				headers: {
					'xt-user-token': null
				}
			})
				.then((response) => {
					// console.log(response)
					successNotify("Faq Deleted Successfully")
					handleCloseDeleteModal();
					// getPermissions();

				})
				.catch((error) => {

				});

		} catch (err) {
			console.log(err)
		}
	};
	const handleCreateModal = () => {
		// setIsEditing(false);
		// setFormData({ question: '', answer: '', type: '' })
		// setOpenModal(true)
	};
	const handleEditModal = (val) => {
		// setIsEditing(true);
		// setFormData({ question: val.question, answer: val.answer, type: val.type, creator_id: val.creator_id, id: val.id })
		// setOpenModal(true)
	};


	const handleOpenDeleteModal = (val) => {
		// setFormData({ id: val.id })
		// setOpenDeleteModal(true)
	};
	const handleCloseDeleteModal = () => {
		// setFormData({ question: '', answer: '', type: '' })
		// setOpenDeleteModal(false)
	};

	const handleSubmit = async () => {

		if (!isEditing) {

			try {

				await Api.post(endPoints?.permissions?.create, {
					id: '0',
					description: data.description,
					title: data.title,
					rule_set: data.rule_set,
					enabled: data.enabled,
					consumer: data.consumer,
					displayed: true
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getPermissions();
						successNotify("Permissions Created Successfully")

					})
					.catch((error) => {

					});

			} catch (error) {
				if (error?.response?.data) {
					errorNotify(error?.response?.data?.message);
				}
			}

		} else {


			try {

				await Api.put(`${endPoints?.permissions?.update}/${data?.id}`, {
					id: data.id,
					method: data.method,
					description: data.description,
					title: data.title,
					rule_set: data.rule_set,
					enabled: data.enabled,
					consumer: data.consumer,
					displayed: true
				}, {
					headers: {
						'xt-user-token': null
					}
				})
					.then((response) => {
						handleCloseModal();
						getPermissions();
						successNotify("Permissions Updated Successfully")

					})
					.catch((error) => {

					});

			} catch (error) {
				if (error?.response?.data) {
					errorNotify(error?.response?.data?.message);
				}
			}
		}
	};






	const handleEnable = event => {
		setDialogData(prevData => ({
			...prevData,
			enabled: event.target.checked,
		}));
		// setEnabled(event.target.checked);
	};

	const onInputChange = e => {
		if (e.target.name === 'rule_set') {
			const ruleIndex = data.rule_set.indexOf(e.target.value);

			let updatedRules;

			if (ruleIndex === -1) {
				updatedRules = [...data.rule_set, e.target.value];
			} else {
				updatedRules = data.rule_set.filter(rule => rule !== e.target.value);
			}
			setRules(updatedRules);
			setDialogData(prevData => ({
				...prevData,
				rule_set: updatedRules,
			}));
		}
	};

	const handleMethodChange = e => {

		const value = e.target.value;
		setDialogData(prevData => {
			let newMethod = [];
			if (value === 1) newMethod = userRules.app;
			else if (value === 3) newMethod = userRules.frontend;
			else if (value === 2) newMethod = userRules.backend;
			else if (value === 4) newMethod = [];

			return {
				...prevData,
				consumer: value,
				displayRules: newMethod,
			};
		});

		if (value !== '0') {
			setShowRuleSet(true);
		} else {
			setShowRuleSet(false);
		}
	};

	return (
		<>

			<Flex jc='flex-end' gap='1rem' mb='2rem' fw='wrap'>

				<TransitionsModal
					open={isOpen}
					handleClose={handleCloseModal}
					modalTitle={isEditing ? "Update Permissions" : "Create Permissions"}
				>

					<Grid gtc='repeat(auto-fit, minmax(20rem, 1fr))' >
						<Grid gtc='repeat(auto-fit, minmax(10rem, 1fr))' margin='2.5rem 0' padding='2rem'>
							<Box>
								<MarginHandler width='100%'>
									<InputControl
										state={data?.title}
										onChange={handleChange}
										inputProps={{ maxLength: 60 }}
										label='Title'
										name='title'
										required
									/>
								</MarginHandler>
								<MarginHandler mt={"2em"} width='100%'>
									<InputControl
										state={data?.description}
										onChange={handleChange}
										inputProps={{ maxLength: 120 }}
										label='Description'
										name='description'
										required
									/>
								</MarginHandler>


								{!isEditing ? (
									<MarginHandler mt={"2em"} width='100%'>
										<FormControl fullWidth>
											<InputLabel id="demo-simple-select-label">Type</InputLabel>
											<Select
												// style={{".MuiButtonBase-root":{fontSize:"2em !important"}}}
												labelId="demo-simple-select-label"
												id="demo-simple-select"
												defaultValue="Select Consumer"
												onChange={handleMethodChange}
												value={data?.consumer}
											>
												<MenuItem className='font-face-M' value={0}>Select Customer</MenuItem>
												<MenuItem className='font-face-M' value={1}>Application</MenuItem>
												<MenuItem className='font-face-M' value={3}>FrontEnd</MenuItem>
												<MenuItem className='font-face-M' value={2}>Backend</MenuItem>
											</Select>
										</FormControl>
									</MarginHandler>
								) : null}


								<MarginHandler mt={"2em"} width='100%'>
									<FormControlLabel
										control={<Checkbox checked={data?.enabled} onChange={handleEnable} />}
										label="Enabled"
									/>
								</MarginHandler>
							</Box>


						</Grid>
						<Grid gtc='repeat(auto-fit, minmax(10rem, 1fr))' margin='2.5rem 0' padding='2rem'>

							<List dense>
								{data?.displayRules ?

									data?.displayRules.map(value => {
										const labelId = `checkbox-list-secondary-label-${value}`;
										let lbl = value;
										lbl = value.replaceAll('_', " ")

										return (
											<ListItem sx={{ ".MuiListItemText-primary": { fontSize: "1.5em" } }} key={value} button>
												<ListItemText id={labelId} primary={`${lbl}`} sx={{marginRight:"1em"}} />
												<ListItemSecondaryAction>
													<Checkbox
														sx={{
															'& .MuiSvgIcon-root': { fontSize: 22 }
														}
														}
														name={'rule_set'}
														value={value}
														edge="end"
														onChange={onInputChange}
														checked={data.rule_set?.includes(value) && true}
														inputProps={{ 'aria-labelledby': labelId }}
													/>
												</ListItemSecondaryAction>
											</ListItem>
										);
									}) : null

								}
							</List>
						</Grid>



					</Grid>
					<Button
						color='primary'
						variant='contained'
						onClick={handleSubmit}
						style={{
							background: colorGreenGradient,
							fontSize: '1.6rem',
							textTransform: 'none',
							padding: '0.7rem 2rem',
							color: colorWhite,
							borderRadius: '0.5rem',
							float: "right",
							margin: "0em 1.5em 2em 0em"
						}}
						className='font-face-R'>
						{isEditing ? "Update " : "Create "}
					</Button>
				</TransitionsModal>
			</Flex>
		</>
	);
};

export default PermissionsDialog;
